<template>
  <div class="ucrs-property__inner">
    <p class="text-xl font-bold mb-9">
      Popolazione residente nella zona per fasce di età
    </p>
    <div class="flex items-center my-8">
      <SvgIcon name="people" class="max-w-13 h-13" />
      <p class="font-bold text-3xl mx-6">
        {{ parseInt(population.p1.qt).toLocaleString('it-IT') }}
      </p>
      <p class="text-xl">persone</p>
    </div>
    <ColumnStatistics :items="percentages" />
  </div>
</template>

<script>
/* eslint-disable camelcase */

import percentRound from 'percent-round'

import ColumnStatistics from '~/components/ColumnStatistics.vue'

export default {
  components: {
    ColumnStatistics,
  },
  props: {
    population: {
      type: Object,
      default: () => {
        return null
      },
    },
  },
  computed: {
    percentages() {
      const p14_p15_perc = this.population.p14_p15_perc
      p14_p15_perc.label = '0 - 9 anni'
      const p16_p17_perc = this.population.p16_p17_perc
      p16_p17_perc.label = '10 - 19 anni'
      const p18_p19_p20_perc = this.population.p18_p19_p20_perc
      p18_p19_p20_perc.label = '20 - 34 anni'
      const p21_p22_p23_p24_p25_perc = this.population.p21_p22_p23_p24_p25_perc
      p21_p22_p23_p24_p25_perc.label = '35 - 59 anni'
      const p26_p27_p28_perc = this.population.p26_p27_p28_perc
      p26_p27_p28_perc.label = '60 - 74 anni'
      const p29_perc = this.population.p29_perc
      p29_perc.label = '74+ anni'
      const percs = [
        this.population.p14_p15_perc,
        this.population.p16_p17_perc,
        this.population.p18_p19_p20_perc,
        this.population.p21_p22_p23_p24_p25_perc,
        this.population.p26_p27_p28_perc,
        this.population.p29_perc,
      ]

      const rounded = percentRound(
        percs.map((el) => {
          return el.qt
        })
      )

      percs.forEach((el, i) => {
        el.qt = rounded[i]
      })

      return percs
    },
  },
}
</script>
